import React from 'react';
import { PricePrice } from 'src/types';
import { ShippingLabel as ShippingLabelComponent } from 'src/components/shipping-label';
import { PriceDisplay } from 'src/components/price-list/types';
import { FontEmphasis } from '@prisjakt/ui/text';

interface IShippingLabel {
  className?: string;
  emphasis?: FontEmphasis;
  price?: PricePrice | null;
  priceDisplay: PriceDisplay;
}

export const ShippingLabel: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IShippingLabel>
>> = props => {
  const {
    className,
    emphasis = FontEmphasis.MEDIUM,
    price,
    priceDisplay,
  } = props;

  if (!price || !price.exclShipping) {
    return null;
  }

  return (
    <ShippingLabelComponent
      className={className}
      emphasis={emphasis}
      exclShipping={price.exclShipping}
      inclShipping={price.inclShipping}
      priceDisplay={priceDisplay}
    />
  );
};
